import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets//success.png'


const _hoisted_1 = { style: {"width":"100%","margin":"0 auto","background":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = {
  key: 0,
  style: {"margin":"40px 0","background":"#fff","padding":"30px","border-radius":"12px"}
}
const _hoisted_3 = { style: {"font-size":"0.14rem","color":"#333333","margin-bottom":"0.16rem"} }
const _hoisted_4 = {
  key: 1,
  class: "uploadForm_"
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  class: "",
  style: {"padding-bottom":"10px","font-size":"14px","display":"flex","align-items":"center"}
}
const _hoisted_7 = { style: {"display":"block","width":"100%"} }
const _hoisted_8 = {
  key: 1,
  class: "",
  style: {"width":"10rem","height":"430px","margin":"0px auto","padding":"40px 0 20px"}
}

import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { ref, onBeforeMount, onMounted, nextTick, watch } from "vue";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'JoinActivity',
  setup(__props) {

const upload_action = ref(serverBaseUrl + "/file/upload");
const route = useRoute();
const router = useRouter();
const formRef = ref(null);
const radio1 = ref("");
const uploadSuccessShow = ref(false);
const radio_type = ref("1");
const radioChange = (e: string) => {
    if (e == '2') {
        form.value.rests = [{
            key: 1,
            realName: "",
            telphone: "",
            email: "",
            identity: ""
        }, {
            key: 2,
            realName: "",
            telphone: "",
            email: "",
            identity: ""
        }]
    } else {
        form.value.rests = []
    }
    radio_type.value = e;
}
const form: any = ref({
    activityId: route.query.id,
    realName: undefined,
    telphone: undefined,
    email: undefined,
    joinFile: undefined,
    workFile: undefined,
    rests: [],
    idCardNumber: ""
});
const types_ = ref("");
const getInfo = function () {
    Axios("get", "/system/activity/" + route.query.id, null, false, function (res: any) {
        if (res.data.code == 200) {
            types_.value = String(res.data.data.otherType);
        } else {
            ElMessage.error(res.data.message);
        }
    });
};
(route as any).query.activityType == 2 && getInfo()
const backDetail = () => {
    router.back()
}
const jx = () => {
    router.push({
        path: "/AddMaterial",
        query: (route as any).query.activityType == 3 ? {
            activityId: route.query.activityId,
            id: route.query.id,
            activityType: 3
        } : { id: route.query.id, activityType: route.query.activityType }
    });
}
var isCardId = (rule, value, callback) => {
    if (value) {
        const reg =
            /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
        const card = reg.test(value);
        if (!card) {
            callback(new Error("身份证号格式有误！"));
        } else {
            callback();
        }
    } else {
        callback();
    }
    callback();
};
const checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        const reg = /^1[0-9]{10}$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的手机号'));
        }
    }
}
const xzbtn = () => {
    open('/agreement?name=hdxz', '_blank')
}
const checkPhone_ = (rule, value, callback) => {
    if (!value) return callback();
    const reg = /^1[0-9]{10}$/
    if (reg.test(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的手机号'));
    }
}
var checkEmail = (rule, value, cb) => {
    //验证邮箱的正则表达式
    const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
    if (regEmail.test(value)) {
        //合法的邮箱
        return cb();
    }
    //邮箱不合法
    cb(new Error('请输入合法的邮箱！'));
}
var checkEmail_ = (rule, value, cb) => {
    if (!value) return cb();
    //验证邮箱的正则表达式
    const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
    if (regEmail.test(value)) {
        //合法的邮箱
        return cb();
    }
    //邮箱不合法
    cb(new Error('请输入合法的邮箱！'));
}
// const rules = ref({
//     realName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
//     telphone: [{
//         required: true, trigger: "blur", validator: checkPhone
//     }],
//     email: [{ required: true, message: "电子邮箱不能为空", trigger: "blur" }, { validator: checkEmail, trigger: 'blur' }]
// })
const fileList = ref([[], []])
const onSuccess = (idx: number, res: any) => {
    if (idx == 0)
        form.value.joinFile = res.data.url;
};
const handleProgress = (idx: number, list: any) => {
    fileList.value[idx] = list;
}
function submitForm() {
    formRef.value?.validate((valid, fields) => {
        if (valid) {
            // if ((route as any).query.activityType != 2 && !form.value.joinFile) {
            //     ElMessage.error('请上传报名表');
            //     return
            // }
            if (!radio1.value) {
                ElMessage.error('请勾选大赛征集规则等所有条款');
                return
            }
            form.value.type = radio_type.value;
            form.value.otherJson = JSON.stringify(form.value.rests.map((item: any, index: number) => {
                return {
                    realName: form.value.rests[index].realName,
                    telphone: form.value.rests[index].telphone,
                    email: form.value.rests[index].email,
                    identity: form.value.rests[index].identity,
                }
            }));
            Axios("post", "/system/activity-join", (route as any).query.activityType == 3 ? Object.assign(form.value, {
                activityId: route.query.activityId,
                taskId: route.query.id,
            }) : form.value, false, function (res) {
                if (res.data.code == 200) {
                    if ((route as any).query.activityType == 2) {
                        uploadSuccessShow.value = true;
                        return
                    }
                    router.push({
                        path: "/AddMaterial",
                        query: (route as any).query.activityType == 3 ? {
                            activityId: route.query.activityId,
                            id: route.query.id,
                            activityType: 3
                        } : { id: route.query.id, activityType: route.query.activityType }
                    });
                } else {
                    ElMessage.error(res.data.message);
                }
            });
        }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "container",
      style: _normalizeStyle({ width: (_unref(route) as any).query.activityType == 2 ? '11.4rem' : '10rem' })
    }, [
      (!uploadSuccessShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Back)
                ]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"padding-left":"10px"} }, "填写报名信息", -1))
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"color":"#86909C"} }, [
              _createElementVNode("span", null, "基本信息")
            ], -1)),
            ((_unref(route) as any).query.activityType == 2 && types_.value == '1')
              ? (_openBlock(), _createBlock(_component_el_radio_group, {
                  key: 0,
                  modelValue: radio_type.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((radio_type).value = $event)),
                  onChange: radioChange,
                  style: {"margin-top":"24px","margin-bottom":"4px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { value: "1" }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("个人报名")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "2" }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("团队报名")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form, {
              ref_key: "formRef",
              ref: formRef,
              style: {"margin-top":"20px"},
              inline: "",
              model: form.value,
              "label-width": "100px",
              "label-position": "top",
              "status-icon": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名",
                  prop: "realName",
                  style: {"width":"225px"},
                  rules: [{ required: true, message: "姓名不能为空", trigger: "blur" }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.realName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.realName) = $event)),
                      "show-word-limit": "",
                      maxlength: "6",
                      placeholder: "请输入姓名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "手机号",
                  prop: "telphone",
                  style: {"width":"225px"},
                  rules: [{
                        required: true, trigger: "blur", validator: checkPhone
                    }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.telphone,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.telphone) = $event)),
                      "show-word-limit": "",
                      maxlength: "11",
                      placeholder: "请输入手机号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_el_form_item, {
                  label: "电子邮箱",
                  prop: "email",
                  style: {"width":"273px"},
                  rules: [{ required: true, message: "电子邮箱不能为空", trigger: "blur" }, { validator: _unref(checkEmail), trigger: "blur" }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.email,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.email) = $event)),
                      "show-word-limit": "",
                      maxlength: "30",
                      placeholder: "请输入电子邮箱"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                ((_unref(route) as any).query.activityType == 2)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      style: {"width":"225px"},
                      label: "身份证号",
                      prop: "idCardNumber",
                      rules: [{ required: true, message: "身份证号不能为空", trigger: "blur" }, {
                            validator: _unref(isCardId), trigger: "blur"
                        }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.idCardNumber,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.idCardNumber) = $event)),
                          "show-word-limit": "",
                          maxlength: "30",
                          placeholder: "请输入身份证号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["rules"]))
                  : _createCommentVNode("", true),
                (radio_type.value == '2')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"color":"#86909C","margin-bottom":"24px"} }, [
                        _createElementVNode("span", null, "其他成员")
                      ], -1)),
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.rests, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.key,
                            style: {"display":"flex","align-items":"center","width":"100%"}
                          }, [
                            _createVNode(_component_el_form_item, {
                              label: "姓名",
                              style: {"width":"225px"},
                              prop: 'rests.' + index + '.realName',
                              rules: ('realName' + index) == 'realName0' ? [{ required: true, message: '姓名不能为空', trigger: 'blur' }] : []
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: item.realName,
                                  "onUpdate:modelValue": ($event: any) => ((item.realName) = $event),
                                  "show-word-limit": "",
                                  maxlength: "6",
                                  placeholder: "请输入姓名"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"]),
                            _createVNode(_component_el_form_item, {
                              label: "手机号",
                              style: {"width":"225px"},
                              prop: 'rests.' + index + '.telphone',
                              rules: ("telphone" + index) == "telphone0" ? [{
                                        required: true, trigger: "blur", validator: checkPhone
                                    }] : [{
                                        required: false, validator: checkPhone_, trigger: "blur"
                                    }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: item.telphone,
                                  "onUpdate:modelValue": ($event: any) => ((item.telphone) = $event),
                                  "show-word-limit": "",
                                  maxlength: "11",
                                  placeholder: "请输入手机号"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"]),
                            _createVNode(_component_el_form_item, {
                              style: {"width":"273px"},
                              label: "电子邮箱",
                              prop: 'rests.' + index + '.email',
                              rules: ("email" + index == "email0") ? [{ required: true, message: "电子邮箱不能为空", trigger: "blur" }, {
                                    validator: _unref(checkEmail), trigger: "blur"
                                }] : [{
                                    required: false, validator: _unref(checkEmail_), trigger: "blur"
                                }]
                                    
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: item.email,
                                  "onUpdate:modelValue": ($event: any) => ((item.email) = $event),
                                  "show-word-limit": "",
                                  maxlength: "30",
                                  placeholder: "请输入电子邮箱"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"]),
                            _createVNode(_component_el_form_item, {
                              style: {"width":"225px"},
                              label: "身份证号",
                              prop: 'rests.' + index + '.identity',
                              rules: ("identity" + index == "identity0") ? [{ required: true, message: "身份证号不能为空", trigger: "blur" }, {
                                        validator: _unref(isCardId), trigger: "blur"
                                    }] : [{
                                        required: false, validator: _unref(isCardId), trigger: "blur"
                                    }]
                                        
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: item.identity,
                                  "onUpdate:modelValue": ($event: any) => ((item.identity) = $event),
                                  "show-word-limit": "",
                                  maxlength: "30",
                                  placeholder: "请输入身份证号"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"height":"37px","line-height":"37px","color":"#ff8741","font-weight":"400","font-size":"14px","padding-left":"8px","width":"100%","background":"#ff874126","border-radius":"8px","margin-bottom":"5px"} }, [
                  _createElementVNode("span", null, "填写报名信息后，即可上传参赛作品！")
                ], -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: radio1.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((radio1).value = $event)),
                    label: "",
                    size: "large"
                  }, null, 8, ["modelValue"]),
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "我已同意大赛征集规则及", -1)),
                  _createElementVNode("span", {
                    style: {"color":"#409eff","cursor":"pointer"},
                    onClick: xzbtn
                  }, "《活动须知》"),
                  _cache[12] || (_cache[12] = _createElementVNode("span", { style: {"color":"#606266"} }, "所有条款", -1))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "large",
                    style: {"min-width":"280px","font-size":"16px","height":"45px"},
                    onClick: submitForm
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_unref(route) as any).query.activityType == 2 ? "立即报名" : "下一步"), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ]))
        : _createCommentVNode("", true),
      (uploadSuccessShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", { style: {"height":"100%","background":"#FFF","border-radius":"8px","display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"} }, [
              _cache[17] || (_cache[17] = _createElementVNode("img", {
                src: _imports_0,
                style: {"width":"48px","height":"48px"},
                alt: "",
                srcset: ""
              }, null, -1)),
              _cache[18] || (_cache[18] = _createElementVNode("div", { style: {"color":"#333333","font-size":"14px","margin-top":"16px"} }, [
                _createElementVNode("span", null, "报名成功")
              ], -1)),
              _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"color":"#86909c","font-size":"14px","margin-top":"4px"} }, [
                _createElementVNode("span", null, "已报名成功，可前往上传参赛作品")
              ], -1)),
              _createElementVNode("div", { style: {"display":"flex","align-items":"center","column-gap":"20px","margin-top":"24px"} }, [
                _createElementVNode("div", {
                  onClick: backDetail,
                  style: {"width":"116px","height":"37px","text-align":"center","line-height":"37px","border":"1px solid #2978FF","border-radius":"8px","color":"#2978ff","font-size":"14px","cursor":"pointer"}
                }, _cache[15] || (_cache[15] = [
                  _createElementVNode("span", null, "返回活动详情", -1)
                ])),
                _createElementVNode("div", {
                  onClick: jx,
                  style: {"width":"88px","height":"37px","text-align":"center","line-height":"37px","background":"#2978FF","border-radius":"8px","color":"#FFF","font-size":"14px","cursor":"pointer"}
                }, _cache[16] || (_cache[16] = [
                  _createElementVNode("span", null, "上传作品", -1)
                ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})